/**
 * Obtiene el origen del navegador sin impedir que el módulo se cargue fuera de él.
 *
 * @returns Origen actual o un origen neutro cuando `window` no está disponible.
 */
function getBrowserOrigin(): string {
    if (typeof window === 'undefined') {
        return 'http://localhost'
    }

    return window.location.origin
}

/**
 * Elimina las barras iniciales y finales de un segmento de ruta.
 *
 * @param value - Segmento que se desea normalizar.
 * @returns Segmento sin barras exteriores.
 */
function normalizarSegmento(value: string): string {
    return value.replace(/^\/+|\/+$/g, '')
}

/**
 * Construye una URL absoluta sin duplicar ni perder separadores.
 *
 * @param path - Ruta relativa que se añadirá a la base.
 * @param basePath - Prefijo opcional de la aplicación.
 * @param origin - Origen absoluto; por defecto se utiliza el del navegador.
 * @returns URL absoluta normalizada.
 */
export function buildAppUrl(path: string, basePath = '', origin = getBrowserOrigin()): string {
    const base = [normalizarSegmento(basePath), ''].filter((segment, index) => segment || index > 0).join('/')
    const normalizedOrigin = `${origin.replace(/\/+$/, '')}/`
    const normalizedPath = path.replace(/^\/+/, '')

    return new URL(normalizedPath, new URL(base, normalizedOrigin)).toString()
}
